module.exports = __webpack_public_path__ + "img/ic_twiiter.08deed60.png";